import { UserInfoService } from 'src/app/core/services/user-info.service';

import { Component } from '@angular/core';

import { DrawerService } from '../../services/drawer.service';
import { AuthService } from '@auth0/auth0-angular';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'user-menu',
  standalone: false,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.sass']
})
export class UserMenuComponent {
  constructor(
    private auth: AuthService,
    public userInfoService: UserInfoService,
    public drawer: DrawerService,
    private cookieService: CookieService
  ) {}

  logout() {
    this.cookieService.delete('mhm_auth_org_id');

    this.auth.logout({
      logoutParams: {
        returnTo: `${window.location.protocol}//${window.location.host}`
      }
    });
  }
}
